import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import TokenPresenter from './token-presenter';
import { useTranslation } from 'react-i18next';

const KEY_AUTH_CODE = 'code';
const KEY_ERROR = 'error';
const KEY_ERROR_REASON = 'error_reason';
const KEY_ERROR_DESC = 'error_description';

const ERROR_USER_DENIED = 'user_denied';

// const CLIENT_ID = '1502448763241044';
// {"clientId":"1103318530495487","clientSecret":"110d201c56cd58a34c1898a21ab7bcf5"}
// const CLIENT_ID = '1103318530495487';
const CLIENT_ID = '1666250297630706';

export function extractFromUrl(key) {
  const url = new URL(window.location.href);
  const value = url.searchParams.get(key);
  delete url.searchParams.delete(key);
  window.history.replaceState({}, document.title, url.href);
  return value;
}

const REDIRECT_URI = process.env.REACT_APP_INSTAGRAM_REDIRECT_URI || 'https://localhost:3000/instagram/';
const API_URL = process.env.REACT_APP_API_URI || 'https://dev-api.dsplay.tv';

function Token() {

  const { t } = useTranslation();

  const [loading, setLoading] = useState(true);
  const [accessToken, setAccessToken] = useState();
  const [username, setUsername] = useState();
  const [error, setError] = useState();

  const handleOnGenerate = useCallback(() => {
    const url = `https://instagram.com/oauth/authorize?client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URI}&response_type=code&scope=instagram_business_basic`;
    window.location = url;
  }, []);

  const handleCopy = () => {
    if (navigator && navigator.clipboard) {
      navigator.clipboard.writeText(accessToken).then(function () {
      }, function () {
        alert(t('Error copying to Clipboard. Try copying it manually!'));
      });
    } else {
      alert(t('Error copying to Clipboard. Try copying it manually!'));
    }
  };

  const handleReload = () => window.location.reload(false);

  useEffect(() => {
    (async () => {
      try {
        const code = extractFromUrl(KEY_AUTH_CODE);

        if (code) {
          const tokenUrl = `${API_URL}/token/exchange`;
          const params = {
            provider: 'instagram',
            code,
            redirectUri: REDIRECT_URI,
          };

          console.log(tokenUrl, params);

          const response = await axios.get(tokenUrl, { params });

          console.log(response.data);

          const {
            username,
            token,
          } = response.data;

          try {
            await axios.get('https://graph.instagram.com/me/media', {
              params: {
                access_token: token,
              }
            });

            setAccessToken(token);
            setUsername(username);
          } catch (e) {
            console.log(e);
            setError(new Error('You haven\'t allowed DSPLAY to read your Instagram media.'));
          }
        } else {
          const error = extractFromUrl(KEY_ERROR);
          if (error) {
            const errReason = extractFromUrl(KEY_ERROR_REASON);
            const errDesc = extractFromUrl(KEY_ERROR_DESC);

            throw new Error(errReason === ERROR_USER_DENIED ? 'You have denied the required access.' : errDesc);
          }
        }
      } catch (e) {
        console.error(e);
        if (e.isAxiosError) {
          console.error(e.response);
          if (e.response) {
            console.error(JSON.stringify(e.response.data, null, 2));
          }
        }

        setError(e);
      }
      setLoading(false)
    })();
  }, []);

  // console.log('loading:', loading, 'error:', error, 'token:', accessToken, 'username:', username);

  return (
    <TokenPresenter
      loading={loading}
      accessToken={accessToken}
      username={username}
      error={error}
      onGenerate={handleOnGenerate}
      onCopy={handleCopy}
      onReload={handleReload}
    />
  );
}

export default Token;